module.exports = __webpack_public_path__ + "img/jl-12.ee2743dc.png";